export default __webpack_public_path__ + "static/media/pencil-white.74aafade.svg";